/**
 * Vrací informaci, jestli je ID pozitivní (větší než nula)
 * @returns Jestli je ID pozitivní
 */
export const HasPositiveID = (id?: string) => id && id.trim() !== "0" && !id.trim().startsWith("-");
